import { CommonModule } from '@angular/common';
import { HttpHeaders } from '@angular/common/http';
import { inject, NgModule } from '@angular/core';
import { InMemoryCache } from '@apollo/client/core';
import { provideApollo } from 'apollo-angular';
import { HttpLink } from 'apollo-angular/http';

import { environment } from '../../environments/environment';
import { SharedModule } from '../shared/shared.module';

@NgModule({
	imports: [CommonModule, SharedModule],
	providers: [
		provideApollo(() => {
			const httpLink = inject(HttpLink);
			const headers = new HttpHeaders({
				'apollographql-client-name': 'Public Web',
				'apollographql-client-version': '1.0.0',
			});

			return {
				// Apollo Client 4 always adds __typename; addTypename was removed.
				cache: new InMemoryCache(),
				link: httpLink.create({
					uri: environment.graphQLEndpoint,
					headers,
				}),
				name: 'Public Web',
				version: '1.0.0',
				defaultOptions: {
					query: {
						fetchPolicy: 'no-cache',
					},
					mutate: {
						fetchPolicy: 'no-cache',
					},
				},
			};
		}),
	],
})
export class GraphqlModule {}
